import { Agent, Channel } from '@nemuru-eng/js-api-client';
import { useCallback } from 'react';

import { ChannelOrAgentDropdownSelector } from '@/components/shared/components/AgentSelectionComponent/components/ChannelOrAgentDropdownSelector';
import { AgentMap } from '@/components/shared/components/AgentSelectionComponent/maps/agent.map';
import { AgentSelectionComponentStateSetter } from '@/components/shared/components/AgentSelectionComponent/types/AgentSelectionComponentStateSetter';
import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';
import { Text } from '@/components/shared/components/Text';

interface AgentSelectorProps {
  selectedChannel: Channel | undefined;
  selectedAgent: Agent | undefined;
  setState: AgentSelectionComponentStateSetter;
}

export const AgentSelector = ({ selectedChannel, selectedAgent, setState }: AgentSelectorProps) => {
  const allAgents = selectedChannel?.agents;
  const disabled = !selectedChannel;
  const resetItem = useCallback(() => !selectedAgent, [selectedAgent]);

  return (
    <ChannelOrAgentDropdownSelector
      title={<Text tId={'SALES_AGENT'} />}
      subtitle={<Text tId={'SELECT_AN_AGENT'} />}
      resetItem={resetItem}
      icon={'person'}
      disabled={disabled}
      value={selectedAgent ? AgentMap.toSelectItem(selectedAgent) : undefined}
      items={allAgents?.map(AgentMap.toSelectItem) as SelectItem[]}
      handleClickItem={(item) => {
        setState((state) => ({ ...state, selectedAgent: allAgents?.find((agent) => agent.id === item.id) }));
      }}
    />
  );
};
